<template>
  <v-flex xs12>
    <slot name="content" />
  </v-flex>
</template>

<script>
export default {
    name: 'AddFamilyTemplateContent',
    inject: ['$validator']
};
</script>

<style scoped></style>
